<template>
	<div>
		<div class="layout mx-auto bg-whiteDashboard">
			<div class="flex flex-col h-screen">
				<header-home />
				<main class="mb-auto text-navyBlue">
					<div class="mx-4">
						<div>
							<p class="text-3xl py-4"><b>Daftar</b> Komisi</p>
						</div>
					</div>
					<div class="mx-4">
						<div class="text-center">
							<div class="mx-auto bg-white p-4 rounded-md mb-4">
								<div class="px-11">
									<div class="text-left pt-2 flex">
										<img
											class=" mr-5"
											src="../../assets/dashboard/home/dompet.svg"
											alt="komisi"
											srcset=""
										/>
										<p class="text-lg">
											Jumlah <b>Komisi</b> <br />kamu saat ini
										</p>
									</div>
									<div>
										<div class="flex text-center">
											<p class="flex-1 text-right pt-3 text-lg">
												Rp
											</p>
											<p class="flex-auto text-5xl py-3 text-left">
												888.000
											</p>
										</div>
									</div>
									<div>
										<button
											class=" font-semibold w-full max-w-xl outline-none focus:outline-none bg-lightPurple text-white py-2 uppercase rounded-md"
											type="submit"
										>
											<b>Penarikan</b>
										</button>
									</div>
								</div>
							</div>
							<div class="mx-auto rounded-md mb-4 w-full">
								<div class="flex">
									<div class="bg-white p-4 mr-2">
										<div class="text-left pt-2 flex">
											<img
												class=" mr-2 w-8"
												src="../../assets/dashboard/home/note-comission.svg"
												alt="halaman"
												srcset=""
											/>
											<p class="text-sm">Jumlah <b>Komisi</b> sepanjang masa</p>
										</div>
										<div class="flex text-center">
											<p class="flex-1 text-right pt-3 text-sm">
												Rp
											</p>
											<p class="flex-auto text-3xl pt-2 text-left ">
												7.125.000
											</p>
										</div>
									</div>
									<div class="bg-white p-4 ml-2">
										<div class="text-left pt-2 flex">
											<img
												class=" mr-2 w-8"
												src="../../assets/dashboard/home/note-comission.svg"
												alt="halaman"
												srcset=""
											/>
											<p class="text-sm">Jumlah <b>Komisi</b> yang ditarik</p>
										</div>
										<div class="flex text-center">
											<p class="flex-1 text-right pt-3 text-sm">
												Rp
											</p>
											<p class="flex-auto text-3xl pt-2 text-left ">
												500.000
											</p>
										</div>
									</div>
								</div>
							</div>
							<div class="mx-auto bg-white p-4 rounded-md mb-4">
								<div class="px-11">
									<div class="text-left pt-2 flex">
										<img
											class=" mr-5"
											src="../../assets/dashboard/home/update-rek.svg"
											alt="halaman"
											srcset=""
										/>
										<p class="text-md pt-3"><b>Perbarui</b> Rekening Kamu</p>
									</div>
									<div>
										<form class="text-navyBlue" @submit.prevent="updateRek">
											<div class="text-left">
												<select
													v-model="Selected"
													class="w-full h-10 bg-white my-1 pl-2 outline-none text-gray-400"
												>
													<option disabled value="">Pilih Bank</option>
													<option value="A" class=" text-navyBlue">A</option>
													<option value="B" class=" text-navyBlue">B</option>
													<option value="C" class=" text-navyBlue">C</option>
												</select>

												<input
													class="px-3 py-2 mt-1 outline-none w-full my-1 h-10"
													required
													v-model="RekNumber"
													type="text"
													placeholder="ex. 731-025-2527"
												/>
												<input
													class="px-3 py-2 mt-1 outline-none w-full my-1 h-10"
													required
													v-model="RekName"
													type="text"
													placeholder="Masukan nama rekening"
												/>
											</div>
											<button
												class="font-semibold w-full max-w-xl outline-none focus:outline-none bg-lightPurple text-white py-2 mt-2 uppercase rounded-md"
												type="submit"
											>
												<span class="button-login"><b>Perbarui</b></span>
											</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mx-4 text-left mb-20">
						<div class=" ">
							<div
								class="flex w-full border text-center rounded-md h-9  mb-3 border-gray-300"
							>
								<div class="w-3/5 border-r border-gray-300 pt-1">
									<p>Total Komisi per-tanggal</p>
								</div>
								<div class="w-2/5 pt-1">
									<p class="font-bold">Rp150.000</p>
								</div>
							</div>
							<div class="text-center w-full">
								<form @submit.prevent="checkComission">
									<div class="flex ">
										<input
											class="w-1/2 flex-1 border rounded-md h-9 date mb-3 border-gray-300 pt-1 mr-1"
											type="date"
											v-model="StartDate"
										/>
										<input
											class="w-1/2 flex-1 border rounded-md h-9 date mb-3 border-gray-300 pt-1 mr-1"
											type="date"
											v-model="EndDate"
										/>
										<div class=" pt-1">
											<button
												type="submit"
												class=" bg-navyBlue text-white h-9 -mt-1 rounded-md float-right outline-none focus:outline-none"
											>
												<img
													class=" w-full p-2"
													src="../../assets/dashboard/home/magnifier.svg"
													alt="halaman"
													srcset=""
												/>
											</button>
										</div>
									</div>
								</form>
							</div>

							<div class="w-full bg-navyBlue h-1 rounded-t-xl"></div>
							<table class="text-center w-full h-auto bg-whiteBase ">
								<thead class="text-xs bg-navyBlue text-white h-8  font-light ">
									<tr class="px-8 text-left">
										<th class="font-light text-center pl-1">No.</th>
										<th class="font-light">ID Komisi</th>
										<th class="font-light">Keterangan</th>
										<th class="font-light">Komisi</th>
										<th class="font-light">Tanggal</th>
									</tr>
								</thead>
								<tbody class="text-xs font-light ">
									<tr class=" border-gray-100 border-b-2 h-12 text-left">
										<td class="pl-1 text-center">1.</td>
										<td>123456</td>
										<td>
											Komisi dari <br />
											Landing Page
										</td>
										<td>30.000</td>
										<td>31/03/2021 10:23</td>
									</tr>
								</tbody>
							</table>
							<hr class="border-navyBlue border-b-2" />
							<div class=" pt-4 pb-4 bg-whiteBase rounded-b-sm text-center">
								<div class="mx-auto">
									<div class="pagination">
										<button class="mx-auto" href="#">1</button>
										<button href="#" class="active">2</button>
										<button href="#">3</button>
										<button href="#">4</button>
										<button href="#">5</button>
										<button href="#">6</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				<footer class="static">
					<div class=" mb-0 pb-0 h-full">
						<p class=" bg-navyBlue py-2 text-sm text-whiteBase">
							©2021 joinme.id | All Right Reserved
						</p>
					</div>
				</footer>
				<menus />
			</div>
		</div>
	</div>
</template>
<script>
import Menus from "./items/Menus.vue";
import Header from "./items/Header.vue";
export default {
	name: "home",
	components: {
		menus: Menus,
		"header-home": Header,
	},
	data() {
		return {
			Selected: "",
			RekName: "",
			RekNumber: "",
			StartDate: "",
			EndDate: "",
		};
	},
	methods: {
		updateRek: function() {
			alert("updateRek");
		},
		checkComission: function() {
			alert("checkComission");
		},
	},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400;500;600;700&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span,
button,
div,
input,
ul,
li {
	font-family: "Karla", sans-serif;
}
.font-tebel {
	font-weight: 600;
}
.dot {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.dot-active {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.home-table {
	padding-top: 25px;
}
input,
select,
option {
	border: 1px solid #999999;
	border-radius: 5px;
}
.date {
	border: 1px solid #cecece;
	padding-left: 8px;
	outline: none;
}
.add {
	max-width: 100%;
	height: auto;
	border-bottom-width: 3px;
	border-radius: 100%;
	border-color: #f9f9f9;
}
.pagination {
	display: inline-block;
}

.pagination button {
	color: black;
	padding: 6px 12px;
	text-decoration: none;
}

.pagination button.active {
	background-color: #16213e;
	color: white;
	border-radius: 5px;
}

.pagination button:hover:not(.active) {
	background-color: #ddd;
	border-radius: 5px;
}
</style>
